import axios from "axios";

import {
  currentDateInUTC,
  scheduledDateInUTC
} from "../helpers/datetimeHandlers";
import { successHandling } from "../helpers/successHandling";
import { apiSelectedGroupsHandler } from "../helpers/apiSelectedIdsHandler";

export const kioskModeAPI = async (
  device_id,
  devices,
  selectedGroups,
  executeType,
  enableKioskMode,
  enableApplication,
  datetime,
  command,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("device_id", device_id); // single device
  apiSelectedGroupsHandler(formData, devices, selectedGroups); // multiple devices
  formData.append("execute_type", executeType);
  formData.append("enable_kiosk_mode", enableKioskMode);
  formData.append("enable_application", enableApplication);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("close_application_command", command);

  await axios({
    url: `/api/v2/command/kiosk-mode-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
